import { InputAdornment, Typography, makeStyles } from "@material-ui/core";
import React from "react";
import { ReactComponent as NotepadIcon } from "../../../images/examimage/notepadicon.svg";
import { ReactComponent as CheckedIcon } from "../../../images/examimage/checkvector.svg";
import { ReactComponent as CrossIcon } from "../../../images/examimage/crossvector.svg";
import WrongAnswer from "./WrongAnswer";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "75%",
    margin: "2rem auto",
  },
  containerInner: {
    margin: "3rem 0",
    breakInside: "avoid",
  },
  heading: {
    display: "flex",
    alignItems: "center",
    background: "#D7DAF2",
    padding: "0.4rem 3rem",
    borderRadius: "6px",
    "& .MuiTypography-h3": {
      color: "#252525",
      fontSize: "1rem",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "2.625rem",
      textTransform: "capitalize",
    },
  },
  notepadIcon: {
    margin: "0 0.5rem",
  },
  quizContainer: {
    background: "#FCFCFC",
    padding: "1rem 2rem ",
  },
  direction: {
    margin: "2rem 0",
  },
  question: {
    "& .MuiTypography-caption": {
      color: "#727272",
      fontSize: "0.8rem",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "2.625rem",
      textTransform: "capitalize",
    },
    "& .MuiTypography-h6": {
      color: "#252525",
      fontSize: "0.95rem",
      fontStyle: "normal",
      lineHeight: "1.625rem",
      textTransform: "capitalize",
    },
    "& span img": {
      cursor: "zoom-in",
      maxWidth: "100%",
      height: "auto",
    },
    "& img": {
      maxWidth: "100%",
      height: "auto",
    },
  },
  optionsContainer: {
    margin: "3rem 0",
  },
  options: {
    margin: "1rem 0",
    padding: "0.6rem",
    background: "#FFF",
    display: "flex",
    alignItems: "center",
    borderRadius: "6px",
    boxShadow: "0px 6px 20px 0px rgba(0, 0, 0, 0.06)",
    "& .MuiTypography-h6": {
      width: "93%",
      color: "#252525",
      fontSize: "0.8rem",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "1.625rem",
      textTransform: "capitalize",
    },
  },
  rightOption: {
    background: "#EEFFF0",
    border: "2px solid #AAFFB2",
  },
  wrongOption: {
    background: "#FFF2F2",
    border: "2px solid #FFC1C1",
  },
  squareBox: {
    width: "28px",
    height: "28px",
    backgroundColor: "rgba(241, 241, 241, 1)",
    fontWeight: "500",
    color: "rgba(33, 33, 33, 1)",
    fontSize: "18px",
    textTransform: "capitalize",
    borderRadius: "4px",
    fontFamily: "'Jost', sans-serif",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  redSquareBox: {
    backgroundColor: "rgba(255, 57, 57, 1)",
    color: "white",
  },
  greenSquareBox: {
    backgroundColor: "rgba(0, 169, 17, 1)",
    color: "white",
  },
  crossIcon: {
    color: "rgba(255, 252, 244, 1)",
    padding: "0.3rem",
    width: "13px",
    height: "13px",
    backgroundColor: "rgba(255, 57, 57, 1)",
    borderRadius: "6px",
  },

  checkIcon: {
    color: "rgba(255, 255, 255, 1)",
    padding: "0.3rem",
    width: "13px",
    height: "13px",
    backgroundColor: "rgba(0, 169, 17, 1)",
    borderRadius: "6px",
  },
}));

function QuestionsAndOptions({ examResultData }) {
  const classes = useStyles();
  const selectLanguage = "english";

  const getAlphabetLetter = (index) => {
    return String.fromCharCode(65 + index);
  };

  const isSame = (xs, ys, index) => {
    if (xs.sort().join(",") === ys.sort().join(",")) {
      return true;
    }
    return false;
  };
  console.log("examResultData", examResultData);

  const isAnswerInRange = (answer, rangeStr) => {
    if (!answer || !rangeStr) return false;
    const num = parseFloat(answer);
    if (isNaN(num)) return false;
    const match = rangeStr.match(/^(-?\d+\.?\d*)\s*-\s*(-?\d+\.?\d*)$/);
    if (!match) return false;
    const min = parseFloat(match[1]);
    const max = parseFloat(match[2]);
    if (isNaN(min) || isNaN(max)) return false;
    return num >= min && num <= max;
  };

  return (
    <div className={classes.container}>
      {examResultData.result.map((item, index) => {
        const correctOptionIds = item.correct_option_ids ?? [];
        const selectedOptionIds = item.selected_option_ids ?? [];

        const correctOptionMatch = item.correct_match_matrix ?? {};
        const selectedOptionMatch = item.match_matrix ?? {};
        const isMatch = item.question_type.includes("Match");

        const getMatchResult = (correct = {}, selected = {}) => {
          if (!correct || typeof correct !== "object") return [];

          return Object.keys(correct).map((key) => {
            const correctValues = Array.isArray(correct[key])
              ? correct[key]
              : [];

            const selectedValues = Array.isArray(selected?.[key])
              ? selected[key]
              : [];

            const isCorrect =
              correctValues.length === selectedValues.length &&
              correctValues.every((v) => selectedValues.includes(v));

            return {
              question: key, // A, B, C, D
              correct: correctValues, // ["P", "Q"]
              selected:
                selectedValues.length > 1
                  ? selectedValues.join(", ")
                  : (selectedValues[0] ?? ""),
              isCorrect, // true / false
              _selectedArray: selectedValues, // internal use
            };
          });
        };

        // ✅ Get results
        const matchResults = getMatchResult(
          correctOptionMatch,
          selectedOptionMatch,
        );

        // ✅ Check user selected something
        const hasSelectedSomething = matchResults.some(
          (m) => m._selectedArray.length > 0,
        );

        // ✅ Count correct answers
        const correctCount = matchResults.filter((m) => m.isCorrect).length;
        const totalCount = matchResults.length;

        // ✅ Check if all correct
        const isAllCorrect = totalCount > 0 && correctCount === totalCount;

        // ✅ Final Message
        const getFinalMessage = () => {
          if (!hasSelectedSomething) {
            return "Oops! You Have Not Selected Any Option For This Question.";
          }

          // All correct
          if (correctCount === totalCount) {
            return "Your Answer is Correct!";
          }

          // Some correct some wrong
          if (correctCount > 0) {
            return "Your Answer Is Partially Correct.";
          }

          // All wrong
          return "Oops! Your Answer Is Wrong.";
        };

        // ✅ Function for UI usage
        const matchResult = () => {
          if (!correctOptionMatch || !selectedOptionMatch) return [];
          return getMatchResult(correctOptionMatch, selectedOptionMatch);
        };

        let isNoOptionSelected =
          selectedOptionIds.length === 0 && item.answer === "";
        const isFillUp = item.question_type === "Fill In The Blanks";
        const isRange = item.question_type === "Range";
        let correctFillUpOption = null;
        if (isFillUp || isRange) {
          correctFillUpOption =
            item.options.filter((opt) => opt.correct_option)[0] ?? null;
        }
        if (correctFillUpOption) {
          correctFillUpOption = correctFillUpOption?.solution_en;
        }
        return (
          <div key={item.id} className={classes.containerInner}>
            <div className={classes.heading}>
              <NotepadIcon className={classes.notepadIcon} />
              <Typography variant="h3">
                Question {index + 1} / {examResultData.result.length}
              </Typography>
            </div>
            <div className={classes.quizContainer}>
              <div className={classes.question}>
                <Typography
                  variant="caption"
                  dangerouslySetInnerHTML={{
                    __html:
                      selectLanguage === "english"
                        ? item.question_en
                        : item.question_hi,
                  }}
                />
              </div>
              {isMatch && (
                <>
                  <div className={classes.optionsContainer}>
                    {matchResult().map((option) => {
                      const success = option.isCorrect;

                      return (
                        <div
                          key={option.question}
                          className={`${classes.options} ${success ? classes.rightOption : classes.wrongOption
                            }`}
                        >
                          {/* Question key */}
                          <InputAdornment position="start">
                            <div className={classes.squareBox}>
                              {option.question}
                            </div>
                          </InputAdornment>

                          {/* Correct vs Selected */}
                          <Typography variant="h6">
                            Correct:{" "}
                            <strong>{option.correct.join(", ")}</strong>
                            {" | "}
                            Selected:{" "}
                            <strong
                              style={{
                                color: success ? "green" : "red",
                              }}
                            >
                              {option.selected ?? "—"}
                            </strong>
                          </Typography>

                          {/* Icon */}
                          <InputAdornment position="end">
                            {success ? (
                              <CheckedIcon className={classes.checkIcon} />
                            ) : (
                              <CrossIcon className={classes.crossIcon} />
                            )}
                          </InputAdornment>
                        </div>
                      );
                    })}
                  </div>
                  <Typography
                    variant="h6"
                    style={{
                      color: isAllCorrect ? "green" : "red",
                      marginBottom: "8px",
                    }}
                  >
                    {!isAllCorrect && (
                      <CrossIcon
                        className={classes.crossIcon}
                        style={{ borderRadius: "100%", marginRight: 10 }}
                      />
                    )}
                    {getFinalMessage()}
                  </Typography>

                  <Typography variant="body1" className={classes.solutionText}>
                    <span className={classes.spanText}>Answer:</span> The
                    correct option is{" "}
                    {matchResult().length > 0 &&
                      matchResult().map((item) => (
                        <div key={item.question}>
                          <strong>{item.question}</strong> → Correct:{" "}
                          {item.correct.join(", ")}
                        </div>
                      ))}
                  </Typography>
                </>
              )}

              {/* Range type — show typed answer like Fill In The Blanks */}
              {isRange && item.answer && (
                <div className={classes.optionsContainer}>
                  <div
                    className={`${classes.options} ${isAnswerInRange(item.answer, correctFillUpOption)
                      ? classes.rightOption
                      : classes.wrongOption
                      }`}
                  >
                    <Typography variant="h6">{item.answer}</Typography>
                    <InputAdornment position="end">
                      {isAnswerInRange(item.answer, correctFillUpOption) ? (
                        <CheckedIcon className={classes.checkIcon} />
                      ) : (
                        <CrossIcon className={classes.crossIcon} />
                      )}
                    </InputAdornment>
                  </div>
                </div>
              )}

              {(isFillUp && item.answer) || (!isFillUp && !isRange && !isMatch) ? (
                <div className={classes.optionsContainer}>
                  {item.options.map((option, optIndex) => {
                    if (!isFillUp || (isFillUp && option.correct_option)) {
                      let success = null;
                      if (option.correct_option) {
                        success = true;
                        // if (
                        //   isFillUp &&
                        //   option.solution_en != Number(item.answer)
                        // ) {
                        //   success = false;
                        // }

                        if (isRange) {
                          success = isAnswerInRange(item.answer, option.solution_en);
                        } else if (isFillUp && option.solution_en !== item.answer) {
                          success = false;
                        }
                      } else if (selectedOptionIds.includes(option.id)) {
                        success = false;
                      } else if (isFillUp) {
                        success = false;
                      }

                      return (
                        <div
                          key={option.id}
                          className={`${classes.options} ${success === true
                            ? classes.rightOption
                            : success === false
                              ? classes.wrongOption
                              : ""
                            }`}
                        >
                          {isFillUp ? (
                            <></>
                          ) : (
                            <InputAdornment position="start">
                              <div className={`${classes.squareBox}`}>
                                {isFillUp ? "A" : getAlphabetLetter(optIndex)}
                              </div>
                            </InputAdornment>
                          )}
                          <Typography
                            variant="h6"
                            dangerouslySetInnerHTML={{
                              __html: isFillUp
                                ? item.answer
                                : selectLanguage === "english"
                                  ? option.option_en
                                  : option.option_hi,
                            }}
                          />
                          <InputAdornment position="end">
                            {/* {(isFillUp
                              ? option.solution_en == Number(item.answer)
                              : option.correct_option) && (
                              <CheckedIcon className={classes.checkIcon} />
                            )} */}
                            {(isRange
                              ? isAnswerInRange(item.answer, option.solution_en)
                              : isFillUp
                                ? option.solution_en === item.answer
                                : option.correct_option) && (
                                <CheckedIcon className={classes.checkIcon} />
                              )}
                            {/* {((selectedOptionIds &&
                              selectedOptionIds.includes(option.id) &&
                              !option.correct_option) ||
                              (isFillUp &&
                                option.solution_en != Number(item.answer))) && (
                              <CrossIcon className={classes.crossIcon} />
                            )} */}
                            {((selectedOptionIds &&
                              selectedOptionIds.includes(option.id) &&
                              !option.correct_option) ||
                              (isRange
                                ? !isAnswerInRange(item.answer, option.solution_en)
                                : isFillUp &&
                                option.solution_en !== item.answer)) && (
                                <CrossIcon className={classes.crossIcon} />
                              )}
                          </InputAdornment>
                        </div>
                      );
                    } else {
                      return <></>;
                    }
                  })}
                </div>
              ) : (
                <></>
              )}

              {/* Display WrongAnswer component */}
              {isFillUp && correctFillUpOption !== item.answer && (
                <WrongAnswer
                  correctOptionIds={correctOptionIds}
                  options={item.options}
                  selectLanguage={selectLanguage}
                  isNoOptionSelected={isNoOptionSelected}
                  isFillInTheBlank={isFillUp}
                  answer={item?.answer ?? ""}
                  correctFillUpOption={correctFillUpOption}
                  selectedOptionIds={selectedOptionIds}
                  questionType={item.question_type}
                />
              )}
              {isRange && !isAnswerInRange(item.answer, correctFillUpOption) && (
                <WrongAnswer
                  correctOptionIds={correctOptionIds}
                  options={item.options}
                  selectLanguage={selectLanguage}
                  isNoOptionSelected={!item.answer}
                  isFillInTheBlank={false}
                  answer={item?.answer ?? ""}
                  correctFillUpOption={correctFillUpOption}
                  selectedOptionIds={selectedOptionIds}
                  questionType={item.question_type}
                />
              )}
              {!isFillUp &&
                !isRange &&
                !isMatch &&
                (isNoOptionSelected ||
                  !isSame(selectedOptionIds, correctOptionIds)) && (
                  <WrongAnswer
                    correctOptionIds={correctOptionIds}
                    options={item.options}
                    selectLanguage={selectLanguage}
                    isNoOptionSelected={isNoOptionSelected}
                    isFillInTheBlank={isFillUp}
                    answer={item?.answer ?? ""}
                    correctFillUpOption={correctFillUpOption}
                    selectedOptionIds={selectedOptionIds}
                    questionType={item.question_type}
                  />
                )}

              {/* Display success message if the answer is correct */}
              {/* {((isSame(selectedOptionIds, correctOptionIds, index + 1) &&
                selectedOptionIds.length > 0) ||
                correctFillUpOption == Number(item.answer)) && (
                <Typography variant="h6" style={{ color: "green" }}>
                  Your Answer is Correct!
                </Typography>
              )} */}
              {((isSame(selectedOptionIds, correctOptionIds, index + 1) &&
                selectedOptionIds.length > 0) ||
                (isRange
                  ? isAnswerInRange(item.answer, correctFillUpOption)
                  : correctFillUpOption === item.answer)) && (
                  <Typography variant="h6" style={{ color: "green" }}>
                    Your Answer is Correct!
                    {isRange && correctFillUpOption && (
                      <span style={{ fontSize: "0.85em", marginLeft: 8 }}>
                        (Correct Range: {correctFillUpOption})
                      </span>
                    )}
                  </Typography>
                )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default QuestionsAndOptions;
